import { Button, InputAdornment, TextField } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { SMALL_BANNER_W_TITLE } from '../../../../constants/UiBuilderConst';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import CTASelector from '../../../../shared/ui-builder/cta-selector/CTA-Selector';
import RedirectSelector from '../../../../shared/ui-builder/redirect-selector/Redirect-Selector';
import { handleRemoveClick } from '../../../../utils/UiBuilderUtils';
import DraggableTabsList from '../../../../shared/draggable-tabs-list/Draggable-Tabs-List';
import MediaSelector from '../../../../shared/ui-builder/media-selector/Media-Selector';

//1D- Small Hero H2, CTA
const SmallBannerWithTitle = (props) => {
  const { onItemChange, config, groupId, handleError, componentNdx } = props;
  const initialSlide = {
    id: `slide_1`,
    label: `Slide 1`,
    imgURL: null,
    titleH2: '',
    redirectLink: {
      connection: '',
      linkId: '',
      isActive: false,
    },
    cta: {
      isActive: false,
      title: '',
    },
    shadowOverlay: false,
    loopPlayBack: false,
    isVideo: false,
    videoURL: null,
  };
  const [slidesList, setSlidesList] = useState(
    config.slides && config.slides.length
      ? config.slides.map((e, index) => {
          return {
            ...e,
            id: `slide_${index + 1}`,
            label: `Slide ${index + 1}`,
          };
        })
      : [initialSlide],
  );
  const [activeTabIndex, setActveTabIndex] = useState(0);
  const [activeTabContent, setActveTabContent] = useState(slidesList[0]);
  const [error, setError] = useState(null);
  const [isSwapEnabled, setIsSwapEnabled] = useState(false);
  const maxSlidesCount = 20;

  useEffect(() => {
    onItemChange({
      componentName: SMALL_BANNER_W_TITLE,
      config: {
        slides: slidesList.map(({ id, label, ...keepAttrs }) => keepAttrs),
      },
    });
  }, [slidesList, isSwapEnabled]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      setIsSwapEnabled(false);
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === SMALL_BANNER_W_TITLE,
      );
      if (currError && currError.slides.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError.slides.map((o) => o.pos),
        );
        setActveTabIndex(sliderNdx);
        setActveTabContent(slidesList[sliderNdx]);
      }
      setError(currError ?? null);
    }
  }, [handleError]);

  const onTabAdd = () => {
    if (slidesList.length < maxSlidesCount) {
      const tempList = [...slidesList];
      initialSlide.id = `slide_${slidesList.length + 1}`;
      initialSlide.label = `Slide ${slidesList.length + 1}`;
      tempList.push(initialSlide);
      setActveTabContent(initialSlide);
      setSlidesList(tempList);
      setActveTabIndex(tempList.length - 1);
    }
  };

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    }
    if (val?.type) return '';
    return 'required';
  };

  const handleTabData = (val, slideContent, field, moduleName) => {
    const thisError = setErrorField(field, val);
    const newSlidesErr = slidesList?.map((_, idx) => {
      const prev = error?.slides?.find((e) => e?.pos === idx) || { pos: idx };
      return idx === activeTabIndex ? { ...prev, [field]: thisError } : prev;
    });
    setError({ slides: newSlidesErr });
    switch (field) {
      case 'titleH2':
        slideContent.titleH2 = val;
        break;
      case 'imgURL':
        slideContent.imgURL = val;
        break;
      case 'redirect':
        slideContent.redirectLink.connection = val.type;
        slideContent.redirectLink.linkId = val.value;
        break;
      case 'isActive':
        slideContent.redirectLink.isActive = val;
        break;
      case 'isCTAActive':
        slideContent.cta.isActive = val;
        break;
      case 'ctaTitle':
        slideContent.cta.title = val;
        break;
      case 'isVideo':
        slideContent.isVideo = val;
        break;
      case 'shadowOverlay':
        slideContent.shadowOverlay = val;
        break;
      case 'videoURL':
        slideContent.videoURL = val;
        break;
      case 'loopPlayBack':
        slideContent.loopPlayBack = val;
        break;
      default:
        break;
    }
    setSlidesList(
      slidesList.map((slide, index) => {
        if (index === activeTabIndex) {
          return slideContent;
        } else {
          return slide;
        }
      }),
    );
  };

  const onTabChange = (e, value) => {
    setActveTabIndex(value);
    setActveTabContent(slidesList[value]);
  };

  const hasError = (key, isReturnString = false) => {
    const hasSliderError = error?.slides?.find(
      (errorSlider) =>
        errorSlider.pos === activeTabIndex &&
        (errorSlider[key] === 'required' || errorSlider[key] === 'validUrl'),
    );
    if (isReturnString && hasSliderError) return hasSliderError?.videoURL;
    if (hasSliderError) return true;
    return false;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const newTabs = slidesList;
    const draggedTab = newTabs.splice(result.source.index, 1)[0];
    newTabs.splice(result.destination.index, 0, draggedTab);
    setActveTabIndex(result.destination.index);
    setActveTabContent(draggedTab);
    setSlidesList(newTabs);
    setIsSwapEnabled(true);
    onItemChange({
      componentName: SMALL_BANNER_W_TITLE,
      config: {
        slides: slidesList.map(({ id, label, ...keepAttrs }) => keepAttrs),
      },
    });
  };

  return (
    <div className='row my-2 mx-4'>
      <div className='col-md-10'>
        <div className='row mt-4 mb-3'>
          <div className='col-md-12 slide-tabs d-flex horizontal-scroll-styled pb-2'>
            <DraggableTabsList
              onDragEnd={onDragEnd}
              tabs={slidesList}
              onTabChange={onTabChange}
              activeTabIndex={activeTabIndex}
            />
            <div className='ms-2'>
              <Button
                disabled={slidesList.length >= maxSlidesCount}
                variant='outlined'
                size='large'
                color='secondary'
                onClick={(e) => onTabAdd(e)}
              >
                <Add />
              </Button>
            </div>
          </div>
          <div className='col-md-12 pe-5 mt-3'>
            <div className='col-md-12'>
              <TextField
                className='mt-2 col-md-12'
                variant='standard'
                label=''
                value={'Slide ' + activeTabContent?.id?.split('_')[1]}
                InputProps={{
                  style: { color: '#828282' },
                  endAdornment: (
                    <InputAdornment position='end' className='pointer text-underlined'>
                      <span
                        onClick={(e) =>
                          handleRemoveClick(
                            e,
                            activeTabIndex,
                            slidesList,
                            setSlidesList,
                            setActveTabIndex,
                            setActveTabContent,
                          )
                        }
                      >
                        Remove
                      </span>
                    </InputAdornment>
                  ),
                }}
              />
              <CustomUiBuilderTextField
                label='H2 Title'
                required={true}
                className='col-md-12 mt-3'
                value={activeTabContent.titleH2}
                onChangeInput={(e) => handleTabData(e.target.value, activeTabContent, 'titleH2')}
                maxLength={100}
                isAdornment={true}
                endAdornment={true}
                error={!isSwapEnabled && hasError('titleH2')}
              />
              <div className='col-md-12 mt-4'>
                <MediaSelector
                  groupId={groupId}
                  titleH2={'Image'}
                  height={624}
                  width={780}
                  matrix={'px - Full Bleed'}
                  handleTabData={handleTabData}
                  activeTabContent={activeTabContent}
                  isSwapEnabled={isSwapEnabled}
                  setIsSwapEnabled={setIsSwapEnabled}
                  hasError={hasError}
                  ratio={'4:5'}
                />
              </div>
              <div className='col-md-12 mt-4'>
                <CTASelector
                  onValueChange={(e) => handleTabData(e, activeTabContent, 'ctaTitle')}
                  value={activeTabContent.cta.title}
                  onCTAStatusChange={(e) => {
                    handleTabData(e, activeTabContent, 'isCTAActive');
                  }}
                  isActive={activeTabContent.cta.isActive}
                  isRequired={activeTabContent.cta.isActive}
                  error={!isSwapEnabled && hasError('ctaTitle')}
                />
              </div>
              <div className='col-md-12 mt-4'>
                <RedirectSelector
                  onValueChange={(e) => handleTabData(e, activeTabContent, 'redirect')}
                  redirectType={activeTabContent.redirectLink.connection}
                  value={activeTabContent.redirectLink.linkId}
                  onRedirectChange={(e) => {
                    handleTabData(e, activeTabContent, 'isActive');
                  }}
                  isActive={activeTabContent.redirectLink.isActive}
                  error={!isSwapEnabled && hasError('redirect')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallBannerWithTitle;
